import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

const api = process.env.REACT_APP_API_URL;

const GitHubCallback = () => {
  const navigate = useNavigate();
  const called = useRef(false);

  useEffect(() => {
    // Prevent double-invoke in React StrictMode
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      toast.error("GitHub sign-in failed. No authorization code received.");
      navigate("/signin");
      return;
    }

    axios
      .post(`${api}auth/github-signin/`, { code }, { withCredentials: true })
      .then((response) => {
        Cookies.set("access_token", response.data.access, { expires: 10 });
        localStorage.setItem("userdetails", JSON.stringify(response.data.user));
        toast.success("Signed in with GitHub!");
        navigate("/home");
      })
      .catch(() => {
        toast.error("GitHub sign-in failed. Please try again.");
        navigate("/signin");
      });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-600">Signing in with GitHub...</p>
      </div>
    </div>
  );
};

export default GitHubCallback;
